import { __rest } from 'tslib';
import React from 'react';
import styled from 'styled-components';
import { margin, padding, cursor, extractMarginProps, extractPaddingProps } from '@10d/tend-ui-styling';

const Wrapper = styled.span `
  display: inline-flex;
  font-size: ${props => (props.$size ? `${props.$size}px` : 'inherit')};
  color: ${props => props.$color || 'inherit'};
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${margin};
  ${padding};
  ${cursor};
`;
/**
 * Не для публичного использования
 */
const Icon = React.forwardRef((_a, ref) => {
    var { children, size, color, className, cursor } = _a, props = __rest(_a, ["children", "size", "color", "className", "cursor"]);
    const _b = extractMarginProps(props), { rest: withoutMargins } = _b, margins = __rest(_b, ["rest"]);
    const _c = extractPaddingProps(withoutMargins), { rest } = _c, paddings = __rest(_c, ["rest"]);
    const _cursor = (() => {
        if (cursor)
            return cursor;
        if (props.onClick)
            return 'pointer';
    })();
    return (React.createElement(Wrapper, Object.assign({}, rest, { ref: ref, className: ['tend-ui-icon-root', 'anticon', className].filter(Boolean).join(' '), "$size": size, "$color": color, "$cursor": _cursor }, margins, paddings), children));
});

export { Icon };
//# sourceMappingURL=Icon.js.map
